import React, { useReducer, Reducer } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { User } from '../../../data/auth/data-types'
import Button from '../button'

import { useAuth } from '../../../data/hooks/auth'
import { changeFollowStatus } from '../../../data/profile/folllow'
import ProfilePicture from '../profile-picture'

type UserListProps = {
  users: User[]
}

type UserFollowStates = {
    [key: string]: boolean
}

const UserList: React.FunctionComponent<UserListProps> = ({ users }) => {
    const { token, user: currentUser } = useAuth()
    const { t } = useTranslation("common")

    const [followStates, updateFollowState] = useReducer<Reducer<UserFollowStates, UserFollowStates>>(
        (state, newState) => ({ ...state, ...newState }),
        {}
    )
    
    return (
        <Container>
            {
                users.map((user, idx) => (
                    <React.Fragment key={user.public_id}>
                        <ProfilePicture pictureUrl={user.picture} publicId={user.public_id} />
                        <Name>{user.first_name} {user.last_name} </Name>
                        <FollowContainer>
                            { token?.access! && user.public_id !== currentUser?.public_id
                                ? <FollowButton 
                                    following={ followStates[user.public_id] || user.followed_by_me } 
                                    onClick={async () => {
                                        updateFollowState({ 
                                            [user.public_id]: !user.followed_by_me,
                                        })
                                        await changeFollowStatus(user.public_id, followStates[user.public_id] || user.followed_by_me, token?.access!)
                                    }
                                }>
                                    { 
                                        followStates[user.public_id] || user.followed_by_me 
                                            ? t('actions.unfollowUser') 
                                            : t('actions.followUser') 
                                    }
                                </FollowButton>
                                : null
                            }
                        </FollowContainer>
                        { idx !== users.length - 1 && <Divider /> }
                    </React.Fragment>
                ))
            }
        </Container>
    )
}

const Container = styled.div`
  display: grid;
  align-items: center;
  justify-items: start;
  
  grid-template-columns: auto 1fr auto;

  grid-gap: 16px;

  width: 100%;
`

const Name = styled.div``

const FollowButton = styled(Button)<{ following: boolean }>`
    height: fit-content;

    margin-top: 0;
    padding: 10px;
    width: 100%;

    background: ${p => p.following ? p.theme.colors.bg : p.theme.colors.accent};
    color: ${p => p.following ? p.theme.colors.accent : p.theme.colors.bg};
    
    border-color: ${p => p.following ? p.theme.colors.accent : p.theme.colors.bg};
    border-width: 1px;
    border-style: ${p => p.following ? 'solid' : 'none' };
`

const Divider = styled.div`
    display: grid;

    grid-column: 1 / span 3;

    height: 1px;
    width: 100%;

    background: ${p => p.theme.colors.lightGray};
`

const FollowContainer = styled.div`
    width: 100%;
`

export default UserList